export default {
    name: 'determinant',
    serverName: '/api/v1/determinant/progress/',
    apiUrl: '/api/v1/determinant/progress/'
};
